const hamburger = document.getElementById("front-top-nav-hamburger");
const expandedTopNavbar = document.getElementById("front-top-navbar-expanded");
const topLevelTopNavItems = document.querySelectorAll(".toplevel-top-nav-item");
const topNavDropdownToggleItems = document.querySelectorAll(
  ".top-nav-dropdown-toggle-item"
);
const topNavDropdownItems = document.querySelectorAll(".top-nav-dropdown-item");

let currentExpandedNavbarHeight;

hamburger.addEventListener("click", function () {
  let navIcon = this.firstElementChild.firstElementChild;
  if (navIcon.classList.contains("mdi-menu")) {
    topNavOpenMenu();
  } else {
    topNavCloseAllDropdowns(topNavDropdownToggleItems, topNavDropdownItems);
    topNavCloseMenu();
  }
});

topLevelTopNavItems.forEach(function (item) {
  item.addEventListener("click", function () {
    if (item.classList.contains("top-nav-dropdown-toggle-item")) {
      if (item.classList.contains("selected")) {
        topNavToggleDropdown(item);
      } else {
        topNavCloseAllDropdowns(topNavDropdownToggleItems, topNavDropdownItems);
        toggleSelectedItems(topLevelTopNavItems, item);
        topNavOpenDropdown(item);
      }
    } else {
      if (item.classList.contains("selected")) {
        topNavCloseAllDropdowns(topNavDropdownToggleItems, topNavDropdownItems);
      } else {
        topNavCloseAllDropdowns(topNavDropdownToggleItems, topNavDropdownItems);
        toggleSelectedItems(topLevelTopNavItems, item);
      }
    }
  });
});

topNavDropdownItems.forEach(function (item) {
  item.addEventListener("click", function () {
    toggleSelectedItems(topNavDropdownItems, item);
  });
});

window.addEventListener("click", function (e) {
  if (!e.target.closest("#nav-hamburger, #front-top-navbar-expanded")) {
    topNavCloseAllDropdowns(topNavDropdownToggleItems, topNavDropdownItems);
    //topNavCloseMenu();
  }

  if (!e.target.closest(".top-nav-dropdown-toggle-item")) {
    topNavCloseAllDropdowns(topNavDropdownToggleItems, topNavDropdownItems);
  }
});

function topNavOpenMenu() {
  expandedTopNavbar.style.maxHeight = expandedTopNavbar.scrollHeight + "px";
  currentExpandedNavbarHeight = expandedTopNavbar.scrollHeight;
  hamburger.firstElementChild.firstElementChild.classList.replace(
    "mdi-menu",
    "mdi-close"
  );
}

function topNavCloseMenu() {
  if (expandedTopNavbar.style.maxHeight) {
    expandedTopNavbar.style.maxHeight = null;
    currentExpandedNavbarHeight = expandedTopNavbar.scrollHeight;
  }
  hamburger.firstElementChild.firstElementChild.classList.replace(
    "mdi-close",
    "mdi-menu"
  );
}

function topNavOpenDropdownContent(dropdownContent, dropdown_toggle_item) {
  dropdownContent.style.maxHeight = dropdownContent.scrollHeight + 100 + "px";
  currentExpandedNavbarHeight =
    expandedTopNavbar.scrollHeight + dropdownContent.scrollHeight;
  expandedTopNavbar.style.maxHeight = currentExpandedNavbarHeight + "px";
  dropdown_toggle_item
    .querySelector(".mdi-menu-down")
    .classList.replace("mdi-menu-down", "mdi-menu-up");
  dropdownContent.classList.add("opened");
}

function topNavCloseDropdownContent(dropdownContent, dropdown_toggle_item) {
  dropdownContent.style.maxHeight = null;
  currentExpandedNavbarHeight =
    expandedTopNavbar.scrollHeight + dropdownContent.scrollHeight;
  expandedTopNavbar.style.maxHeight = currentExpandedNavbarHeight + "px";
  dropdown_toggle_item
    .querySelector(".mdi-menu-up")
    .classList.replace("mdi-menu-up", "mdi-menu-down");
  if (dropdownContent.classList.contains("opened")) {
    dropdownContent.classList.remove("opened");
  }
}

function topNavCloseAllDropdowns(dropdownToggleItemsList, dropdownItemsList) {
  dropdownItemsList.forEach(function (temp_item) {
    if (temp_item.classList.contains("selected")) {
      temp_item.classList.remove("selected");
    }
  });
  dropdownToggleItemsList.forEach(function (item) {
    let dataAttrValue = item.getAttribute("data-display-dropdown");
    const dropdownContent = document.getElementById(dataAttrValue);
    if (dropdownContent.style.maxHeight) {
      topNavCloseDropdownContent(dropdownContent, item);
    }
  });
}

function topNavOpenDropdown(dropdown_toggle_item) {
  let dataAttrValue = dropdown_toggle_item.getAttribute(
    "data-display-dropdown"
  );
  const dropdownContent = document.getElementById(dataAttrValue);
  topNavOpenDropdownContent(dropdownContent, dropdown_toggle_item);
}

function topNavToggleDropdown(dropdown_toggle_item) {
  let dataAttrValue = dropdown_toggle_item.getAttribute(
    "data-display-dropdown"
  );
  const dropdownContent = document.getElementById(dataAttrValue);
  if (dropdownContent.style.maxHeight) {
    topNavCloseDropdownContent(dropdownContent, dropdown_toggle_item);
  } else {
    topNavOpenDropdownContent(dropdownContent, dropdown_toggle_item);
  }
}

function toggleSelectedItems(all_items, active_item) {
  all_items.forEach(function (temp_item) {
    if (temp_item.classList.contains("selected")) {
      temp_item.classList.remove("selected");
    }
  });
  active_item.classList.add("selected");
}
